/** User-facing labels for the Graph column and requirement graph cards. */

export const GRAPH_COLUMN_TITLE = 'Graph';

export const GRAPH_CARD_TITLE = 'Requirement Graph';

export const GRAPH_DETAILS_MODAL_TITLE = 'Graph Details';

export const GRAPH_EMPTY_STATE_MESSAGE =
  'Select a requirement to view its requirement graph.';

export const GRAPH_DETAILS_EMPTY_OVERVIEW =
  'Generate a graph analysis to see the task overview.';

export const GRAPH_DETAILS_EMPTY_TECHNICAL =
  'Generate a graph analysis to see technical details.';

export const GRAPH_DETAILS_EMPTY_RISKS =
  'Generate a graph analysis to see AI-analyzed risks.';

export const GRAPH_CARD_MENU_LABEL = 'Graph menu';

export const GRAPH_DASHBOARD_HEADER_LABEL = 'Dashboard';

export const GRAPH_VISUALIZATION_HEADER_LABEL = 'Requirement Graph';

export function graphVisualizationHeaderTitle(title: string, shortId?: string): string {
  if (shortId) return `${title} (${shortId})`;
  return title;
}

export const GRAPH_ANALYSIS_BACK_LABEL = 'Back to columns';

export function graphShowAllQuestionsLabel(hiddenQuestionCount: number): string {
  if (hiddenQuestionCount <= 0) return 'Show all questions';
  if (hiddenQuestionCount === 1) return 'Show 1 more question';
  return `Show all questions (+${hiddenQuestionCount})`;
}

export const GRAPH_CHART_VIEW_DETAILS_LABEL = 'View details';

export const GRAPH_ANALYSIS_GENERATE_LABEL = 'Generate graph analysis';

export const GRAPH_ANALYSIS_REGENERATE_LABEL = 'Regenerate graph analysis';

export function graphAnalysisButtonLabel(hasAiCoverageDimensions: boolean): string {
  return hasAiCoverageDimensions
    ? GRAPH_ANALYSIS_REGENERATE_LABEL
    : GRAPH_ANALYSIS_GENERATE_LABEL;
}

export const COVERAGE_RADAR_SERIES_LABELS = {
  requirement: 'Active',
  projectMean: 'Project',
  globalMean: 'Global',
} as const;

const GRAPH_READINESS_GATE_READY_LABEL = 'Gate open — action enabled';
const GRAPH_READINESS_GATE_BLOCKED_LABEL = 'Gate closed — action disabled';
export const GRAPH_TICKET_READINESS_TAB_LABEL = 'Ticket readiness';
export const GRAPH_AGENT_READINESS_TAB_LABEL = 'Agent Readiness';
